import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Home } from '../views/home/Home'

//404
import Error404 from '../views/404'

// 物资管理
    //物资入库
    // manage/assetsEntry
    import { ManageAssetsEntry } from '../views/manage/assetsEntry/view'
    import { ManageAssetsEntryDetails } from '../views/manage/assetsEntry/view/details'
    //物资领取
    // manage/assetsGet
    import { ManageAssetsGet } from '../views/manage/assetsGet/view'
    import { ManageAssetsGetDetails } from '../views/manage/assetsGet/view/details'
    //物资归还
    // manage/assetsReturn
    import { ManageAssetsReturn } from '../views/manage/assetsReturn/view'
    import { ManageAssetsReturnDetails } from '../views/manage/assetsReturn/view/details'
    //物资报废
    // manage/assetsAbandon
    import { ManageAssetsAbandon } from '../views/manage/assetsAbandon/view'
    import { ManageAssetsAbandonDetails } from '../views/manage/assetsAbandon/view/details'
    //物资转移
    // manage/assetsMove
    import { ManageAssetsMove } from '../views/manage/assetsMove/view'
    import { ManageAssetsMoveDetails } from '../views/manage/assetsMove/view/details'
    //物资清理
    // manage/assetsClear
    import { ManageAssetsClear } from '../views/manage/assetsClear/view'
    import { ManageAssetsClearDetails } from '../views/manage/assetsClear/view/details'
    //资产清单
    // manage/assetsList
    import { ManageAssetsList } from '../views/manage/assetsList/view'


// 资产盘点
    //资产盘点
    // inventory/assetsInventory
    import { InventoryAssetsInventory } from '../views/inventory/assetsInventory/view'
    import { InventoryAssetsInventoryDetails } from '../views/inventory/assetsInventory/view/details'

//基础数据
    //数据字典
    // base/dict
    import { BaseDict } from '../views/base/dict/view'
    //物资档案
    // base/assetsArchives
    import { BaseAssetsArchives } from '../views/base/assetsArchives/view'
    import { BaseAssetsArchivesDetails } from '../views/base/assetsArchives/view/details'
    //仓库管理
    // base/warehouseManage
    import { BaseWarehouse } from '../views/base/warehouseManage/view'
    import { WarehouseDatalis } from "../views/base/warehouseManage/view/editDetails"
    //用户管理
    // base/userControl
    import { BaseUserControl } from '../views/base/userControl/view'
    //组织机构
    // base/organization
    import { BaseOrganization } from '../views/base/organization/view'
    //资产分类
    // base/assetsClass
    import { BaseAssetsClass } from '../views/base/assetsClass/view'
    //审批设置
    // base/assetsAsk
    import { BaseAssetsAsk } from '../views/base/assetsAsk/view'
    //申请列表
    // /apply/applyList
    import { ApplyAssetsList } from '../views/apply/applyList/view'
    import { ApplyAssetsListDetails } from '../views/apply/applyList/view/details'
function AppRoute() {
    return (
        <Switch>
            {/* 首页 */}
            <Route exact={true} path={'/'} key="1" component={Home} />

            {/* 物资入库 */}
            <Route exact={true} path={"/manage/assetsEntry"} key="2-1" component={ManageAssetsEntry} />
            <Route exact={true} path={"/manage/assetsEntry/add"} key="2-1-1" component={ManageAssetsEntryDetails} />
            <Route exact={true} path={"/manage/assetsEntry/look"} key="2-1-2" component={ManageAssetsEntryDetails} />
            {/* 物资领取 */}
            <Route exact={true} path={"/manage/assetsGet"} key="2-2" component={ManageAssetsGet} />
            <Route exact={true} path={"/manage/assetsGet/add"} key="2-2-1" component={ManageAssetsGetDetails} />
            <Route exact={true} path={"/manage/assetsGet/edit"} key="2-2-2" component={ManageAssetsGetDetails} />
            <Route exact={true} path={"/manage/assetsGet/look"} key="2-2-3" component={ManageAssetsReturnDetails} />
            {/* 物资归还 */}
            <Route exact={true} path={"/manage/assetsReturn"} key="2-3" component={ManageAssetsReturn} />
            <Route exact={true} path={"/manage/assetsReturn/add"} key="2-3-1" component={ManageAssetsReturnDetails} />
            <Route exact={true} path={"/manage/assetsReturn/look"} key="2-3-2" component={ManageAssetsReturnDetails} />
            {/* 物资报废 */}
            <Route exact={true} path={"/manage/assetsAbandon"} key="2-4" component={ManageAssetsAbandon} />
            <Route exact={true} path={"/manage/assetsAbandon/add"} key="2-4-1" component={ManageAssetsAbandonDetails} />
            <Route exact={true} path={"/manage/assetsAbandon/look"} key="2-4-2" component={ManageAssetsAbandonDetails} />
            {/* 物资转移 */}
            <Route exact={true} path={"/manage/assetsMove"} key="2-5" component={ManageAssetsMove} />
            <Route exact={true} path={"/manage/assetsMove/add"} key="2-5-1" component={ManageAssetsMoveDetails} />
            <Route exact={true} path={"/manage/assetsMove/look"} key="2-5-2" component={ManageAssetsMoveDetails} />
            {/* 物资清理 */}
            <Route exact={true} path={"/manage/assetsClear"} key="2-7" component={ManageAssetsClear} />
            <Route exact={true} path={"/manage/assetsClear/add"} key="2-7-1" component={ManageAssetsClearDetails} />
            <Route exact={true} path={"/manage/assetsClear/look"} key="2-7-2" component={ManageAssetsClearDetails} />
            {/* 资产清单 */}
            <Route exact={true} path={"/manage/assetsList"} key="2-6" component={ManageAssetsList} />

            {/* 资产盘点 */}
            <Route exact={true} path={"/inventory/assetsInventory"} key="3-1" component={InventoryAssetsInventory} />
            <Route exact={true} path={"/inventory/assetsInventory/add"} key="3-1-1" component={InventoryAssetsInventoryDetails} />
            <Route exact={true} path={"/inventory/assetsInventory/edit"} key="3-1-2" component={InventoryAssetsInventoryDetails} />
            <Route exact={true} path={"/inventory/assetsInventory/look"} key="3-1-3" component={InventoryAssetsInventoryDetails} />

            {/* 数据字典 */}
            <Route exact={true} path={'/base/dict'} key="4-1" component={BaseDict} />
            {/* 物资档案 */}
            <Route exact={true} path={"/base/assetsArchives"} key="4-2" component={BaseAssetsArchives} />
            <Route exact={true} path={"/base/assetsArchives/add"} key="4-2-1" component={BaseAssetsArchivesDetails} />
            <Route exact={true} path={"/base/assetsArchives/look"} key="4-2-2" component={BaseAssetsArchivesDetails} />
            {/* 仓库管理 */}
            <Route exact={true} path={"/base/warehouseManage"} key="4-3" component={BaseWarehouse} />
            <Route exact={true} path={"/base/warehouseManage/add"} key="4-3-1" component={WarehouseDatalis} />
            <Route exact={true} path={"/base/warehouseManage/look"} key="4-3-2" component={WarehouseDatalis} />
            {/* 用户管理 */}
            <Route exact={true} path={'/base/userControl'} key="4-4" component={BaseUserControl} />
            {/* 组织机构 */}
            <Route exact={true} path={'/base/organization'} key="4-5" component={BaseOrganization} />
            {/* 资产分类 */}
            <Route exact={true} path={'/base/assetsClass'} key="4-6" component={BaseAssetsClass} />
            {/* 审批设置 */}
            <Route exact={true} path={'/base/assetsAsk'} key="4-7" component={BaseAssetsAsk} />
            {/* 申请列表 */}
            <Route exact={true} path={"/apply/applyList"} key="5-1" component={ApplyAssetsList} />
            <Route exact={true} path={"/apply/applyList/add"} key="5-1-1" component={ApplyAssetsListDetails} />
            <Route exact={true} path={"/apply/applyList/edit"} key="5-1-2" component={ApplyAssetsListDetails} />
            <Route exact={true} path={"/apply/applyList/look"} key="5-1-3" component={ApplyAssetsListDetails} />
            {/* 404 */}
            <Route exact={true} path={'/*'} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute
